<app-modal-body
  [title]="title"
  [description]="description"
  titleId="basic-modal-title"
  descriptionId="basic-modal-description"
  [hasFooter]="true"
>
  @if (closable) {
    <button
      modalClose
      type="button"
      class="basic-modal__close"
      aria-label="Close modal"
      (click)="closeModal()"
    ></button>
  }

  <img
    modalIndicator
    class="basic-modal__icon w-100 h-100"
    [src]="'assets/images/modals/modal-' + icon + '.png'"
    alt=""
    aria-hidden="true"
  />

  @if (errorReference) {
    <app-error-reference modalDescriptionExtra [reference]="errorReference" />
  }
</app-modal-body>

<div class="modal-footer basic-modal__actions">
  <button
    type="button"
    class="c-button c-button--secondary"
    [attr.ngbAutofocus]="alternativeCtaText ? null : ''"
    (click)="selectCta(BasicModalCta.Main)"
  >
    {{ mainCtaText }}
  </button>

  @if (alternativeCtaText) {
    <button
      type="button"
      class="c-button basic-modal__alternative-cta"
      ngbAutofocus
      (click)="selectCta(BasicModalCta.Alternative)"
    >
      {{ alternativeCtaText }}
    </button>
  }
</div>
